import PriceUpdate from "./PriceUpdate";

export default PriceUpdate;
